import { render, staticRenderFns } from "./GiftInvoices.vue?vue&type=template&id=57684615&scoped=true"
import script from "./GiftInvoices.vue?vue&type=script&lang=js"
export * from "./GiftInvoices.vue?vue&type=script&lang=js"
import style0 from "./GiftInvoices.vue?vue&type=style&index=0&id=57684615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57684615",
  null
  
)

export default component.exports